import Clarity from "@microsoft/clarity";
import { useEffect } from "react";

import { useUser } from "@/providers/auth/useUser";

export const useClarityIdentifier = () => {
  const { data: user } = useUser();

  useEffect(() => {
    if (!import.meta.env.VITE_CLARITY_PROJECT_ID) {
      return;
    }

    Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);
    Clarity.consent();
  }, []);

  useEffect(() => {
    if (!import.meta.env.VITE_CLARITY_PROJECT_ID || !user?.email) {
      return;
    }

    Clarity.identify(user.user_id);
    Clarity.setTag("client", user.company_name);
    Clarity.setTag("job_function", user.job_function ?? "none");
  }, [user?.user_id, user?.company_name, user?.job_function]);
};
